import { render } from "./PortfolioStock.vue?vue&type=template&id=30cc9415&scoped=true"
import script from "./PortfolioStock.vue?vue&type=script&lang=js"
export * from "./PortfolioStock.vue?vue&type=script&lang=js"

import "./PortfolioStock.vue?vue&type=style&index=0&id=30cc9415&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Ray Wang\\Desktop\\tubertrader\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cc9415"]])

export default __exports__